export default "__VITE_PUBLIC_ASSET__9e6372e4__"